module.exports = __webpack_public_path__ + "static/cutabove-2021-sm-25c4d9ede3f191f7610959da0b909216.mp4";